import 'jquery';
import 'jquery-focuspoint';
import { Reveal, Sticky } from 'foundation-sites';
import { initForms } from './modules/forms';
import { initNavigation } from './modules/navigation';
import { initGallery } from './modules/gallery';
import { initFontAwesome } from './modules/fontAwesome';
import { initSwiper } from './modules/swiper';
import { initProjectFilters } from './modules/projectFilters';
import { initScrollIndicator } from './modules/scrollIndicator';
import { initInfiniteScroll } from './modules/infinitScroll';

// Expose jQuery to debugbar
if (process.env.NODE_ENV === 'development') {
  global.jQuery = $;
}

(($) => {
  'use strict';

  $(document).foundation();
  $(document).ready(() => {
    initForms();
    initNavigation();
    initGallery();
    initFontAwesome();
    initSwiper();
    initProjectFilters();
    initScrollIndicator();
    initInfiniteScroll();
    $('.focuspoint').focusPoint();
  });

  $(window).scroll((e) => initScrollIndicator());

})(jQuery);
